module.exports = __webpack_public_path__ + "static/media/toyota_bg.5f0611f5.png";